// University of Louisville's undergraduate majors (#2748). Read on
// 2026-10-01 from the official Undergraduate Catalog 2026-2027, Programs of
// Study table (catalog.louisville.edu/undergraduate/programs-study/), which
// gives each program's BA and BS (or discipline-specific) degrees and the
// college or school that offers it. Every BA, BS, BSBA, BBA, BFA, BM, BSN
// and BSW entry is kept; minors and certificates are left out. A program
// with two degrees is listed once per degree, and the 3+3 and 3+4 tracks
// are listed as the catalog lists them. The table's school names are
// written out in full (for example "Engineering" as J.B. Speed School of
// Engineering); "Accountancy/ Accounting" is listed as Accountancy, the
// name the catalog's Undergraduate Degree Programs page uses. The KB's
// majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-louisville",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in UofL's official 2026-2027 Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "American Sign Language Interpreting Studies",
                    "degree": "BS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art and Design",
                    "degree": "BFA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology with a 3+3 Track to PharmD",
                    "degree": "BA"
                },
                {
                    "name": "Biology with a 3+4 Track to DMD",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BS"
                },
                {
                    "name": "Communication with a 3+3 Track to Law",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice with a 3+3 Track to Law",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English with a 3+3 Track to Law",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "General Studies",
                    "degree": "BS"
                },
                {
                    "name": "Geography, Applied",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History with a 3+3 Track to Law",
                    "degree": "BA"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Individualized Major",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Pan-African Studies",
                    "degree": "BA"
                },
                {
                    "name": "Pan-African Studies",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science with a 3+3 Track to Law",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BS"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BS"
                },
                {
                    "name": "Women's, Gender & Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender & Sexuality Studies",
                    "degree": "BS"
                },
                {
                    "name": "Women's, Gender & Sexuality Studies with a 3+3 Track to Law",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BBA"
                },
                {
                    "name": "Business Economics",
                    "degree": "BS"
                },
                {
                    "name": "Business Economics with a 3+3 Track to Law",
                    "degree": "BS"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics with a 3+3 Track to Law",
                    "degree": "BA"
                },
                {
                    "name": "Equine Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Global Supply Chain Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Middle and or Secondary Education",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Leadership and Learning",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Leadership and Learning, Track in Healthcare Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Sport Administration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "J.B. Speed School of Engineering",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Applied Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science & Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Music",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Music Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music General",
                    "degree": "BA"
                },
                {
                    "name": "Music History",
                    "degree": "BM"
                },
                {
                    "name": "Music Instrumental Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Jazz Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Jazz Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music Organ Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Piano Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Theory",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BM"
                },
                {
                    "name": "Music Vocal Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music with Emphasis in Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music, New Media",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Nursing (RN-BSN Online Program)",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing, Accelerated Program",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing, Pre-Licensure Program",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "School of Public Health and Information Sciences",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Kent School of Social Work and Family Science",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "School of Medicine",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Dentistry",
            "source": {
                "label": "University of Louisville Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.louisville.edu/undergraduate/programs-study/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
